import React, { useMemo } from 'react'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import WidgetForm from '../WidgetForm'
import CodeView from '../CodeView'

const SidebarWidget = props => {
  const { classes, config, onConfigChange } = props

  return (
    <div className={classes.root}>
      <WidgetForm
        config={config}
        onConfigChange={onConfigChange}
        showPosition={true}
      />
      <CodeView
        label="HTML"
        buttonLabel="Copy HTML code"
        widgetType="sidebar"
        config={config}
      />
      <CodeView
        label="JavaScript"
        buttonLabel="Copy JavaScript code"
        widgetType="sidebar"
        config={config}
      />
    </div>
  )
}

export default withStyles(styles)(SidebarWidget)
